import FETCH from 'cross-fetch';

export default function notifyServerOfSignup(form,scene,route,setResponses){

  let headers = {
    'Content-Type':'application/json;charset=utf-8',
  }


  let body = JSON.stringify(
    {
      notifyMeInfo:{
        address:form.email,
        name:form.name,
        firstName:form.firstName,
        lastName:form.lastName,
        figureBuilder:true,
        scene
      },
      route,
      scene
    }
  )

  let shouldSendNotifyMeInfo = true;
  if( process.env.NODE_ENV !== 'production'){
    shouldSendNotifyMeInfo = false;
    if( !!navigator.webdriver && window.__testMeta && window.__testMeta.shouldSendNotifyMeInfo ){
      shouldSendNotifyMeInfo = true;
    }
  }

  if( shouldSendNotifyMeInfo ){

    //this was slowing down tests too much...
    //so we needed to make this conditional on actually wanting the email to be sent for some test..
    return FETCH('/sendNotifyMeInfo', {
      mode:'no-cors',
      method:'POST',
      headers,
      body,
    }).then(resp => {
      if( scene === 'forgot' ){
        setResponses({
          client:'We will contact you shortly.'
        })
      }
    }).catch(console.error);
  }

}
